import instance from "./auth";

export const getAllData = async (params) => {
    const {data} = await instance.get("/clients/all", {
        params,
    });
    return data;
}

export const getAll = async (params) => {
    const {data} = await instance.get("/clients", {
        params,
    });
    return data;
}

export const createGetById = (id) => {
    const getById = async (params) => {
        const {data} = await instance.get(`/clients/${id}/missions`, {
            params,
        });
        return data;
    }

    return getById;
}


